import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';
import { DatevNumberStatusesEnum } from '@thinknet-gmbh/platform-common';

export const GET_DATEV_NUMBERS = gql`
  query getDatevNumbers(
    $companyId: String!
    $queryOptions: QueryOptionsInput
    $status: DatevNumberStatusesEnum
  ) {
    getDatevNumbers(companyId: $companyId, queryOptions: $queryOptions, status: $status) {
      collection {
        _id
        datevNumber
        status
        details
        createdBy
      }
      totalCount
    }
  }
`;

export const useGetDatevNumbers = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'datevNumber', sortBy: 1 },
  ]);
  const pageSize = 12;
  const { data } = useQuery(GET_DATEV_NUMBERS, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    skip: !companyId,
    fetchPolicy: 'no-cache',
  });

  const getDatevNumbers = data?.getDatevNumbers || {};

  return {
    collection: getDatevNumbers?.collection || [],
    paginationConfig: {
      total: getDatevNumbers?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'datevNumber', sortBy }]);
      }
    },
  };
};

export const useGetAllDatevNumbers = (companyId?: string, status?: DatevNumberStatusesEnum) => {
  const { data, loading } = useQuery(GET_DATEV_NUMBERS, {
    variables: { companyId, status },
    skip: !companyId || !status,
    fetchPolicy: 'no-cache',
  });

  const collection = data?.getDatevNumbers?.collection || [];

  return {
    collection,
    loading,
  };
};
